import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { consumeManualLogout, getAuth, getSafeRedirectPath, isManualLogout } from "../auth";

const GuestRoute = () => {
  const [searchParams] = useSearchParams();
  const [auth, setAuth] = useState(getAuth());
  const { isLoggedIn, user } = auth;
  const redirect = searchParams.get("redirect");

  useEffect(() => {
    if (!auth.isLoggedIn && isManualLogout()) {
      consumeManualLogout();
    }

    const syncAuth = () => setAuth(getAuth());

    window.addEventListener("auth-change", syncAuth);
    window.addEventListener("storage", syncAuth);

    return () => {
      window.removeEventListener("auth-change", syncAuth);
      window.removeEventListener("storage", syncAuth);
    };
  }, [auth.isLoggedIn]);

  if (isLoggedIn) {
    return <Navigate to={getSafeRedirectPath(redirect, user)} replace />;
  }

  return <Outlet />;
};

export default GuestRoute;
